import { Modal, Tooltip, Typography } from "antd";
import React, { useState, useEffect } from "react";
import CenteredLoading from "../../law-components/CenteredLoading";
import { PdfViewer } from "../../routes/MetaSign/PdfViewer";
import { useMediaQuery } from "react-responsive";
import { ReactComponent as EyeIcon } from "../../assets/assets2_0/eye.svg";
import ScrapingService from "../../services/scraping.service";
import DownloadMevFile from "./DownloadMevFile";

const PreviewMevFileModal = ({ expedient, mevMovement }) => {
    const [isPreviewHovered, setIsPreviewHovered] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [allowDownload, setAllowDownload] = useState(false);

    const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const vw = Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0
    );
    const textDocumentWidth = isTabletOrMobile ? vw * 0.98 : 900;
    const modalWidth = textDocumentWidth;
    const subFactor = isTabletOrMobile ? 50 : 100;

    const bodyStyle = {
        maxHeight: "90vh",
        overflowY: "auto"
    };

    useEffect(() => {
        if (!showModal) return;
        ScrapingService.downloadMevAttachment({
            link: mevMovement.id_tramite_mev,
            filename: mevMovement.observations,
            expedientId: expedient.id
        })
            .then(blob => {
                const objectUrl = URL.createObjectURL(blob);
                setPreviewUrl(objectUrl);
                setAllowDownload(true);
            })
            .catch(err => {
                console.error("Error al previsualizar archivo PJN privado", err);
            });

        return () => {
            if (previewUrl?.startsWith("blob:")) {
                URL.revokeObjectURL(previewUrl);
            }
            setPreviewUrl(null);
            setAllowDownload(false);
        };
    }, [showModal]);

    return (
        <>
            <Modal
                title={
                    <div style={{ width: "95%", display: "flex", alignItems: "center" }}>
                        <Typography.Text style={{ whiteSpace: "normal" }} ellipsis>
                            {mevMovement && mevMovement.observations}
                        </Typography.Text>
                        &nbsp;&nbsp;&nbsp;
                        {allowDownload && (
                            <DownloadMevFile
                                expedientId={expedient.id}
                                link={mevMovement.id_tramite_mev}
                                filename={mevMovement.observations}
                            />
                        )}
                    </div>
                }
                centered
                open={showModal}
                onCancel={() => setShowModal(false)}
                footer={false}
                width={modalWidth}
                bodyStyle={bodyStyle}
                destroyOnClose
            >
                <PdfViewer
                    loadingTip={<CenteredLoading tip="Cargando previsualización" />}
                    w={textDocumentWidth - subFactor}
                    url={previewUrl}
                    reqAuth={!expedient.is_pjn_private}
                />
            </Modal>

            <Tooltip trigger="hover" title="Previsualizar">
                <EyeIcon
                    style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        color: isPreviewHovered ? "#0185F8" : "#002A4E",
                        padding: 0,
                        border: "none",
                        background: "none",
                        fontSize: "17px"
                    }}
                    onMouseEnter={() => setIsPreviewHovered(true)}
                    onMouseLeave={() => setIsPreviewHovered(false)}
                    onClick={() => setShowModal(true)}
                />
            </Tooltip>
        </>
    );
};

export default PreviewMevFileModal;
